module.exports = __webpack_public_path__ + "img/safe_product.fed82300.svg";